import React from 'react'
import PeopleIcon from '@material-ui/icons/People'
import WatchIcon from '@material-ui/icons/Watch'
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid'
import GroupWorkIcon from '@material-ui/icons/GroupWork'
import AccessibilityIcon from '@material-ui/icons/Accessibility'

export function getGroupNavItems({ uniqid, pathname }) {
  if (!uniqid) {
    return [
      {
        key: 'groups',
        label: '個案群組',
        to: '/groups',
        icon: <GroupWorkIcon />,
        active: pathname.startsWith('/groups'),
      },
    ]
  }

  return [
    {
      key: 'patients',
      label: '成員列表',
      to: `/${uniqid}/patients`,
      icon: <PeopleIcon />,
      active: pathname.includes('/patients'),
    },
    {
      key: 'fitbit',
      label: 'Google Health',
      to: `/${uniqid}/fitbit/steps`,
      icon: <WatchIcon />,
      active: pathname.includes('/fitbit') && !pathname.includes('/dashboard'),
      section: '數據總覽',
    },
    {
      key: 'garmin',
      label: 'Garmin',
      to: `/${uniqid}/garmin/steps`,
      icon: <WatchIcon />,
      active:
        pathname.includes('/garmin') &&
        !pathname.includes('garminsdk') &&
        !pathname.includes('/dashboard'),
      section: '數據總覽',
    },
    {
      key: 'garminsdk',
      label: 'Garmin SDK',
      to: `/${uniqid}/garminsdk/hrv`,
      icon: <PhoneAndroidIcon />,
      active: pathname.includes('/garminsdk'),
      section: '數據總覽',
    },
    {
      key: 'longgood',
      label: '龍骨王',
      to: `/${uniqid}/longgood`,
      icon: <AccessibilityIcon />,
      active: pathname.includes('/longgood'),
      section: '數據總覽',
    },
  ]
}
